import parser from 'ua-parser-js'
import AppState from '@/plugins/appstate'
import Logger from '@/plugins/logger'
import {CreateInstance, SetHeader} from './config'
import {TimezoneConverter} from './util'
import usersAPI from './users'
import {history} from './analystic'
import _ from 'lodash'
import {store, session} from '@/api/store'
import appstate from '../plugins/appstate'
const accessAPI = CreateInstance('access')
const authAPI = CreateInstance('auth')
const FileUploadAPI = CreateInstance('file_upload')
var authenticated = false
var _user = null

const auth = (token) => {
  if (token) return (authenticated = true)
  if (authenticated) {
    store.set('user', store.get('user'), new Date().getTime() + 10800000)
  }
  return authenticated
}

const logout = () => {
  let remember = store.get('remember')
  let rememberMode = store.get('rememberMode')
  // let tutorialFlag = store.get('tutorial_v2_0')
  let noticeSkip = store.get('notice_skip')
  let lang = store.get('lang')
  let existAuth = store.get('LMM_MOBILE_EXIST_AUTH')
  let isApplication = store.get('LMM_MOBILE_APPLICATION')
  let popupSkip = store.get('popup_skip')
  let isIconView = store.get('icon_view')
  store.clearAll()
  if (remember) store.set('remember', remember)
  if (rememberMode) store.set('rememberMode', rememberMode)
  // if (tutorialFlag) store.set('tutorial_v2_0', true)
  if (noticeSkip) store.set('notice_skip', noticeSkip)
  if (lang) store.set('lang', lang)
  if (existAuth) store.set('LMM_MOBILE_EXIST_AUTH', existAuth)
  if (isApplication) store.set('LMM_MOBILE_APPLICATION', isApplication)
  if (popupSkip) store.set('popup_skip', popupSkip)
  if (isIconView) store.set('icon_view', isIconView)
  session.remove('token')
  authenticated = false
  return authenticated
}

const user = (value, p, noSync) => {
  if (typeof value === 'string') {
    if (noSync) {
      _user[value] = p
      store.set('user', _user)
      return _user
    }
    let params = {}
    params[value] = p
    return usersAPI.put('0', params)
      .then(resp => {
        _user[value] = p
        store.set('user', _user)
      })
  } else if (typeof value === 'object') {
    const tz = TimezoneConverter('value', value.time_zone_id)
    AppState.Info.timezoneOffset = tz.offset + ' minutes'
    AppState.Info.timezone = tz.name
    _user = value
    store.set('user', _user)
    return _user
  }
  return _user
}

const setPermission = (u, doNotUpdate) => {
  let perm = {}
  if (u.type === 'Manager') {
    perm = {
      isAdmin: true,
      deviceMonitor: true,
      modifyInformation: true,
      useFunction: true,
      viewReport: true,
      CSRemoteControl: true,
      CSFileManager: true,
      CSDeviceManagement: true,
      CSRemoteView: true,
      CSUpdate: true,
      CSThumbnailView: true,
      CSRestart: true
    }
  } else {
    perm.isAdmin = false
    perm.deviceMonitor = true
    perm.modifyInformation = false
    perm.useFunction = false
    perm.viewReport = false
    const authdata = _.map((u.auth_val + '').split(','), v => parseInt(v, 10))
    _.each(authdata, v => {
      if (v === 1) return (perm.deviceMonitor = true)
      if (v === 2) return (perm.modifyInformation = true)
      if (v === 4) return (perm.useFunction = true)
      if (v === 8) return (perm.viewReport = true)
    })
    perm.CSRemoteControl = Boolean(u.auth_remotecontrol)
    perm.CSDeviceManagement = Boolean(u.auth_devicemanagement)
    perm.CSFileManager = Boolean(u.auth_filemanager)
    perm.CSRemoteView = Boolean(u.auth_remoteview)
    perm.CSUpdate = Boolean(u.auth_update)
    perm.CSThumbnailView = Boolean(u.auth_thumbnailview)
    perm.CSRestart = Boolean(u.auth_restart)
  }

  if (!doNotUpdate) {
    AppState.perm = perm
  }

  if (u.use_approval_function === 1) {
    AppState.perm.isApprover = true
    if (u.member_type_id === 6) AppState.perm.isSubManager = true
  }
  return perm
}

const calcLicense = (payment) => {
  if (!payment || !payment.length) return null
  var today = new Date().getTime()
  var license = []
  var expireWarnings = []
  license = _.clone(payment.filter(v => !v.pay_lisence_ref))
  var lastest, lastestString, managerLimit
  for (var i = 0; i < license.length; i++) {
    var pk = license[i].pay_pk
    var expire = new Date(license[i].pay_expire).getTime()
    var type, payDevVol
    var linked = payment.filter(v => v.pay_lisence_ref === pk)
    if (linked.length) {
      for (var n = 0; n < linked.length; n++) {
        type = linked[n].pay_type
        payDevVol = linked[n].pay_dev_vol
        var tmp = new Date(linked[n].pay_expire).getTime()
        if (expire < tmp) {
          license[i].pay_expire = linked[n].pay_expire
          expire = tmp
        }
      }
      license[i].linked = linked

      if (license[i].pay_type === 'Free') {
        license[i].pay_type = type
        license[i].pay_dev_vol = payDevVol
      }
    }
    if (!lastest || lastest < expire) {
      lastest = expire
      lastestString = license[i].pay_expire
    }
    license[i].expireTimeStamp = expire
    license[i].isExpired = today > expire
    license[i].expireWarning = today > expire - 604800000
    if (license[i].expireWarning && !license[i].isExpired) expireWarnings.push(license[i])
  }
  AppState.license = license[license.length - 1].pay_type
  managerLimit = license[license.length - 1].manager_limit
  AppState.isCorporate = AppState.license === 'Corporate' || AppState.license === 'Free'
  return {
    total: {
      count: license.length,
      primaryProdType: AppState.license,
      lastestExpireDate: lastest,
      expireWarnings: expireWarnings,
      lastestExpireDateString: lastestString,
      managerLimit: managerLimit,
      vol: license
        .filter(v => !v.isExpired)
        .reduce((sum, item) => sum + item.pay_dev_vol, 0)
    },
    list: license
  }
}

const getOSId = (name) => {
  var osNames = [
    /Windows/i,
    /Ubuntu|Linux/i,
    /Mac/i,
    /Android/i,
    /IOS/i
  ]
  for (var i = 0; i < osNames.length; i++) {
    if (osNames[i].test(name)) {
      return i + 1
    }
  }
  return 0
}

const getDateFmt = (fmt) => {
  const fmts = [
    'YYYY/MM/DD',
    'MM/DD/YYYY',
    'DD/MM/YYYY'
  ]
  return fmts[fmt - 0]
}

const setDateFmt = (fmtId, fmtValue) => {
  _user.date_fmt_id = fmtId
  _user.dateFmt = fmtValue || getDateFmt(fmtId)
  store.set('user', _user, new Date().getTime() + 10800000)
  return {id: fmtId, value: _user.dateFmt}
}

const getUserData = (token, cb, skipHistoryFlag) => {
  if (token) { SetHeader('token', token) }
  usersAPI.get('0')
    .then(resp => {
      const {objects} = resp.data
      var userData = _.assign(objects,
        {license: calcLicense(objects.pay)},
        {permission: setPermission(objects)},
        {dateFmt: getDateFmt(objects.date_fmt_id)}
      )
      const tz = TimezoneConverter('value', userData.time_zone_id)
      AppState.Info.timezone = tz.name
      AppState.Info.timezoneOffset = tz.offset + ' minutes'
      var profile = userData.mgrid.replace(/[@.]/g, '_')
      userData.profile = profile
      store.set('user', userData, new Date().getTime() + 10800000)
      _user = userData
      authenticated = true

      if (!skipHistoryFlag && token) {
        const ua = parser()
        store.set('ua', ua)
        let params = {
          browser: `${ua.browser.name} v-${ua.browser.major}`,
          dev_os_id: getOSId(ua.os.name),
          type_id: 1 // TYPE login
        }
        history.post('access', params)
      }

      return cb(null, userData)
    })
    .catch(err => {
      Logger.error(err)
      return cb(err)
    })
}

// 에이전트 관련 login 함수
const login = (authdata, cb) => {
  accessAPI.post('', authdata)
    .then(resp => {
      const {objects, status} = resp.data
      if (objects.user_type === 7) throw new Error('UserTypeIs7');
      if (status !== 200) return cb(resp.data)
      if (objects.isLogin !== 'Success') return cb(resp.data)

      const stored = store.get('auth')
      if (stored && stored.mgrid !== authdata.mail) {
        let remember = store.get('remember')
        let rememberMode = store.get('rememberMode')
        // let tutorialFlag = store.get('tutorial_v2_0')
        let noticeSkip = store.get('notice_skip')
        let lang = store.get('lang')
        let existAuth = store.get('LMM_MOBILE_EXIST_AUTH')
        let isApplication = store.get('LMM_MOBILE_APPLICATION')
        let popupSkip = store.get('popup_skip')
        let isIconView = store.get('icon_view')
        store.clearAll()
        if (remember) store.set('remember', remember)
        if (rememberMode) store.set('rememberMode', rememberMode)
        // if (tutorialFlag) store.set('tutorial_v2_0', true)
        if (noticeSkip) store.set('notice_skip', noticeSkip)
        if (lang) store.set('lang', lang)
        if (existAuth) store.set('LMM_MOBILE_EXIST_AUTH', existAuth)
        if (isApplication) store.set('LMM_MOBILE_APPLICATION', isApplication)
        if (popupSkip) store.set('popup_skip', popupSkip)
        if (isIconView) store.set('icon_view', isIconView)
      }
      store.set('auth', objects)
      session.set('token', objects.token)
      getUserData(objects.token, cb)
    })
    .catch(err => {
      if (err.message === 'UserTypeIs7') {
        alert('파트너 아이디로 로그인 할 수 없습니다.')
      } else {
        Logger.log(err);
      }
    })
}

const requestEmail = (params) => {
  params.type = 'resend'
  return authAPI.post('', params)
    .then(resp => resp.data.objects)
}

const checkAuth = (key) => {
  let params = { key, type: 'auth' }
  return authAPI.post('', params)
    .then(resp => resp.data.objects)
}

export default accessAPI
export { auth, user, login, logout, accessAPI, SetHeader, requestEmail, checkAuth, getUserData, FileUploadAPI, setDateFmt, setPermission, calcLicense }
